import React from 'react';
import { useTranslation } from 'react-i18next';
import WarningAlertComponent from '../../WarningAlert.component';
import { ChildAlertProps } from '../../BaseAlert.component';

const GoogleCalendarEventDeleteAlertComponent = ({
  handleConfirm,
}: ChildAlertProps) => {
  const { t } = useTranslation();

  return (
    <WarningAlertComponent onClose={handleConfirm}>
      {t('calendarEvent.deleteConfirm')}
    </WarningAlertComponent>
  );
};

export default GoogleCalendarEventDeleteAlertComponent;
